"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Allow Download Button',
  description: "Add a download icon to each item. Note, in iOS devices (iPad, iPod and iPhone) this option is\n  not relevant and the download button will not be shown.",
  isRelevant: function isRelevant() {
    return true;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false
};
exports["default"] = _default;